import { render, staticRenderFns } from "./GetStarted.vue?vue&type=template&id=e22ab530&scoped=true"
import script from "./GetStarted.vue?vue&type=script&lang=ts"
export * from "./GetStarted.vue?vue&type=script&lang=ts"
import style0 from "./GetStarted.vue?vue&type=style&index=0&id=e22ab530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22ab530",
  null
  
)

export default component.exports